export const TeamCategoryTypeEnum = {
    DAILY_TASK: 'daily-task',
    WORK_GROUP: 'work-group',
};
//# sourceMappingURL=team-category.types.js.map